import React, { Fragment } from 'react'
import SafeSearchTerms from '../../mdx/trust-and-safety/safe-search-terms.mdx'
import DocsPageGlobalStyles from '../../styles/docs-page'
import Anchor from '../anchor'
import DividerLine from '../shared/divider-line'

const DocsSection = ({ children, anchorId, dividerLine = false }) => {
    return (
        <section>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor id={anchorId} />
            {children}
        </section>
    )
}

const OptionalSettings = () => {
    return (
        <Fragment>
            <DocsPageGlobalStyles />
            <div className="docsContainer">
                <DocsSection anchorId="safe-search-terms">
                    <SafeSearchTerms />
                </DocsSection>
            </div>
        </Fragment>
    )
}

export default OptionalSettings
